"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _react = _interopRequireDefault(require("react"));
var _useTimeout = require("./useTimeout");
var _Icons = _interopRequireDefault(require("../Icons"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Toast = props => {
  (0, _useTimeout.useTimeout)(props.close, 5000);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-toast"
  }, props.type === 'success' && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex toast-type"
  }, /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: "ok"
  })), props.type === 'warning' && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex toast-type"
  }, /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: "warning"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-direction-column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex toast-title color-text"
  }, props.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex toast-text color-text-secondary"
  }, props.text)), /*#__PURE__*/_react.default.createElement(_Icons.default, {
    onClick: props.close,
    className: "toast-close",
    name: "close",
    width: "18px",
    height: "18px"
  }));
};
exports.Toast = Toast;